import { Flex, Image } from '@chakra-ui/react';

/**
 * Het ademende AME-logo midden in beeld, zoals `Layout` van het origineel liet zien zolang
 * spel en speler nog niet geladen waren.
 */
export function Laadscherm() {
  return (
    <Flex w="full" h="full" justifyContent="center" alignItems="center" role="status">
      <Image className="breathe" src="/icons/ame-logo.png" w="min(200px, 25%)" alt="Laden..." />
    </Flex>
  );
}
